// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mute-logo[data-v-6506006f] {\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 16px;\n  right: 5px;\n}\n.top-logo[data-v-6506006f] {\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 0px;\n  right: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
